import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Sessão do portal do freelancer — o segundo mundo de autenticação.
 *
 * O campo é `accessToken`, o MESMO nome dos outros dois slices. Até 21/09/2026
 * este slice gravava `token` e espelhava no `localStorage`, enquanto
 * `PrivateRoute`, `PublicRoute` e o `DefaultRedirect` liam `accessToken` — e por
 * isso a sessão de freelancer nunca era reconhecida por eles (BUG-006). Com um
 * nome só, um guard único enxerga os três mundos.
 *
 * A persistência é só pelo redux-persist (`whitelist` em `store.ts`). O
 * `localStorage.freelancerToken` saiu: dois lugares guardando a mesma sessão foi
 * exatamente como o bug nasceu.
 */
type FreelancerSessionPayload = {
  accessToken: string;
  cpf: string;
  nomeCompleto?: string;
};

type FreelancerAuthState = {
  accessToken: string | null;
  cpf: string | null;
  nomeCompleto: string | null;
};

const initialState: FreelancerAuthState = {
  accessToken: null,
  cpf: null,
  nomeCompleto: null,
};

const freelancerAuthSlice = createSlice({
  name: "freelancerAuth",
  initialState,
  reducers: {
    setFreelancerSession(state, action: PayloadAction<FreelancerSessionPayload>) {
      state.accessToken = action.payload.accessToken;
      state.cpf = action.payload.cpf;
      state.nomeCompleto = action.payload.nomeCompleto ?? null;
    },
    clearFreelancerSession(state) {
      state.accessToken = null;
      state.cpf = null;
      state.nomeCompleto = null;
    },
  },
});

export const { setFreelancerSession, clearFreelancerSession } =
  freelancerAuthSlice.actions;

export default freelancerAuthSlice.reducer;
